export default {
  Creator: c => `/group/${c.groupId}/${c.creatorId}/${c.provider}/`,
  Topic: t => `/topic/${t.topicId}/`,
  Wizard: p => `/wizard/${p.provider}/${p.postId}`
}
